import axios from 'axios'
import config from '../config'
import LocalStorageService from './LocalStorageService'

export default function apiTruststoreFactory () {
  const authorization = LocalStorageService.getAuthorization()

  return axios.create({
    baseURL: config.TRUSTSTORE_BASE_BACKEND_URL,
    headers: { authorization }
  })
}

export const downloadBlob = (fileName, blob) => {
  const fileURL = window.URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.href = fileURL
  a.className = 'invisible'
  a.setAttribute('download', fileName)
  document.body.appendChild(a)

  a.click()
  a.remove()
}
